import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
import { getAppHeader } from "../../../configs/config";
import { FORECLOSURE_HANDLING, foreclosureCheck } from "../../../configs/utils";
import { api } from "../../../configs/api";
export const goBack = async (action, _datastore, { goBack, navigate }) => {
    await navigate(ROUTE.MY_PROFILE);
};
export const navigateToReasonPage = async (action, _datastore, { navigate, network, setDatastore, instrumentTrack }) => {
    instrumentTrack('STILL_WANT_TO_CLOSE_ACCOUNT_BUTTON_CLICKED', {
        source_page: 'account_closure_landing_page',
    });
    const user = await SharedPropsService.getUser();
    const showForeclosureCheck = await foreclosureCheck();
    let inProgressHeader = '';
    let description = '';
    await setDatastore(action.routeId, 'foreclosure', {
        headerTitle: '',
        subtitle: '',
        errorModal: false,
        inProgressType: '',
    });
    if (showForeclosureCheck) {
        const processInProgressResponse = await network
            .get(`${api.processInProgress}${user.linkedCredits[0].creditId}`, {
            headers: await getAppHeader(),
            handleFromMF: true
        });
        if (processInProgressResponse?.status === 200) {
            await navigate(ROUTE.FORECLOSURE_REASON);
        }
        else if (processInProgressResponse?.response?.status === 400) {
            const voltErrorCode = processInProgressResponse?.response?.data?.voltErrorCode;
            const title = processInProgressResponse?.response?.data?.message;
            switch (voltErrorCode) {
                case FORECLOSURE_HANDLING.UNLIEN_IN_PROCESS:
                    inProgressHeader = "Unpledge request in progress";
                    description = "You will be able to continue with foreclosure as soon as the request is complete. Check transaction details for more info.";
                    break;
                case FORECLOSURE_HANDLING.DISBURSAL_IN_PROCESS:
                    inProgressHeader = "Withdrawal transaction in progress";
                    description = "You will be able to foreclose as soon as the withdrawal is complete. Check transaction details for more info.";
                    break;
                case FORECLOSURE_HANDLING.REPAYMENT_IN_PROCESS:
                    inProgressHeader = "Repayment accounting in progress";
                    description = "You will be able to foreclose as soon as the repayment is accounted. Check transaction details for more info.";
                    break;
                case FORECLOSURE_HANDLING.FORECLOSURE_BUSINESS_HOUR_CHECK:
                    inProgressHeader = "Foreclosure not allowed";
                    description = "Foreclosure requests can only be submitted between 6 AM and 11 PM. Please try again during these hours.";
                    break;
                default:
                    inProgressHeader = title;
                    description = "";
                    break;
            }
            await setDatastore(action.routeId, 'foreclosure', {
                headerTitle: inProgressHeader,
                subtitle: description,
                errorModal: true,
                inProgressType: voltErrorCode,
            });
        }
        else {
            inProgressHeader = 'Something went wrong';
            description = "Unexpected error occurred, please reload app to try again.";
            await setDatastore(action.routeId, 'foreclosure', {
                headerTitle: inProgressHeader,
                subtitle: description,
                errorModal: true,
                inProgressType: '',
            });
        }
    }
};
export const navigateToDashboardPage = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('KEEP_ACCOUNT_ACTIVE_BUTTON_CLICKED', {
        source_page: 'account_closure_landing_page',
    });
    await navigate(ROUTE.DASHBOARD);
};
export const closeModal = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, 'foreclosure', {
        headerTitle: '',
        subtitle: '',
        errorModal: false,
    });
};
export const inProgressProcessNavigateAction = async (action, _datastore, { navigate }) => {
    const inProgressProcessType = action?.payload?.value;
    switch (inProgressProcessType) {
        case "REPAYMENT_IN_PROCESS":
        case "DISBURSAL_IN_PROCESS":
            await navigate(ROUTE.TRANSACTIONS);
            break;
        case "UNLIEN_IN_PROCESS":
            await navigate(ROUTE.PLEDGE_HISTORY, {
                fromInProgressProcess: true
            });
            break;
    }
};
